<template>
  <div class="flex flex-col items-center w-full px-2">
    <Stepper :currentStep="step" :steps="steps" />
    <component
      :is="currentStepComponent"
      v-bind="stepComponentProps"
      v-on="stepComponentListeners"
    />
  </div>
</template>

<script>
import Stepper from './Stepper.vue'
import SubscriptionStep from './SubscriptionStep.vue'
import CreateClientSetup from './CreateClientSetup.vue'
import ReviewStep from './ReviewStep.vue'

export default {
    name: 'ReoptWizard',

  components: { Stepper, SubscriptionStep, CreateClientSetup, ReviewStep },
  props: {
    client: { type: Object, default: null },
    user: { type: Object, default: null },
    userHasSubscription: { type: Boolean, default: false }
  },
  data() {
    return {
      step: 1,
      steps: ['Info', 'Subscription', 'Review'],
      formData: null,
      plans: [],
      selectedPlan: null,
      localClient: null,
      localUser: null,
    }
  },
  computed: {
    currentStepComponent() {
      // Maps step index to component name
      return [CreateClientSetup, SubscriptionStep, ReviewStep][this.step - 1] || 'div';
    },
    stepComponentProps() {
      switch (this.step) {
        case 1:
          return {
            formData: this.formData,
            readOnly: !!this.localClient,
            client: this.localClient,
            user: this.localUser,
          };
        case 2:
          return {
            plans: this.plans,
            selectedPlan: this.selectedPlan,
          };
        case 3:
          return {
            client: this.localClient,
            user: this.localUser,
            plans: this.plans,
            selectedPlan: this.selectedPlan,
          };
        default:
          return {};
      }
    },
    stepComponentListeners() {
      switch (this.step) {
        case 1:
          return {
            'signup-setup-complete': this.onClientSetupComplete,
            'back-to-edit': this.onBackToEdit,
          };
        case 2:
          return {
            'plan-selected': this.onPlanSelected,
            'next': this.nextStep,
            'prev': this.prevStepWithFormData,
            'plans-loaded': this.onPlansLoaded,
          };
        case 3:
          return {
            'next': this.nextStep,
            'prev': this.prevStep,
          };
        default:
          return {};
      }
    }
  },
  methods: {
    nextStep() {
      if (this.step < this.steps.length) this.step++;
    },
    prevStep() {
      if (this.step > 1) this.step--;
    },
    prevStepWithFormData() {
      this.step = 1;
    },
    onClientSetupComplete({ client, user, formData }) {
      if (client && client.id) client.id = Number(client.id);
      this.localClient = client;
      this.localUser = user;
      this.formData = formData;
      this.nextStep();
    },
    onBackToEdit(formData) {
      this.formData = formData;
      this.localClient = null;
      this.localUser = null;
      this.step = 1;
    },
    onPlanSelected(plan) {
      this.selectedPlan = plan;
      this.nextStep();
    },
    onPlansLoaded(plans) {
      this.plans = plans;
    }
  },
  created() {
    this.localClient = this.client;
    this.localUser = this.user;
    if (this.localClient && this.localUser && !this.userHasSubscription) {
      this.step = 2;
    }
  }
}
</script>
